// extracted by mini-css-extract-plugin
export default {"picRow":"Profile_picRow__eaYKg","profileCard":"Profile_profileCard__UbVVq","nftsContainer":"Profile_nftsContainer__nfIKI"};